export const getBidderSemantic = async ({ request, accountId }) => {
  return await request(`/api/v1/ozon/${accountId}/bidder/semantic`);
};

export const saveBidderSemantic = async ({ request, accountId, periodFrom, periodTo, keywords }) => {
  return await request(`/api/v1/ozon/${accountId}/bidder/semantic`, {
    method: 'POST',
    body: JSON.stringify({ period_from: periodFrom, period_to: periodTo, keywords }),
  });
};

export const clearBidderSemantic = async ({ request, accountId }) => {
  return await request(`/api/v1/ozon/${accountId}/bidder/semantic`, { method: 'DELETE' });
};

export const getAutoSeoSemantics = async ({ request, accountId }) => {
  return await request(`/api/v1/ozon-auto-seo/${accountId}/semantics`);
};

export const getBidderConfig = async ({ request, accountId }) => {
  return await request(`/api/v1/ozon/${accountId}/bidder/config`);
};

export const updateBidderConfig = async ({ request, accountId, config }) => {
  return await request(`/api/v1/ozon/${accountId}/bidder/config`, {
    method: 'PUT',
    body: JSON.stringify(config),
  });
};

export const getBidderDashboard = async ({ request, accountId, days = 14 }) => {
  return await request(`/api/v1/ozon/${accountId}/bidder/dashboard?days=${days}`);
};

export const getBidderProducts = async ({ request, accountId }) => {
  return await request(`/api/v1/ozon/${accountId}/bidder/products`);
};

export const getBidderProductSemantic = async ({ request, accountId, skuId }) => {
  return await request(`/api/v1/ozon/${accountId}/bidder/products/${skuId}/semantic`);
};

export const startBidderProductStrategy = async ({ request, accountId, skuId, strategy }) => {
  return await request(`/api/v1/ozon/${accountId}/bidder/products/${skuId}/strategy`, {
    method: 'POST',
    body: JSON.stringify(strategy),
  });
};

export const stopBidderProductStrategy = async ({ request, accountId, skuId }) => {
  return await request(`/api/v1/ozon/${accountId}/bidder/products/${skuId}/strategy`, {
    method: 'DELETE',
  });
};

export const getBidderStrategyDashboard = async ({ request, accountId, skuId, days = 3 }) => {
  return await request(
    `/api/v1/ozon/${accountId}/bidder/products/${skuId}/strategy/dashboard?days=${days}`
  );
};

export const updateBidderExecutionMode = async ({ request, accountId, skuId, executionMode }) => {
  return await request(
    `/api/v1/ozon/${accountId}/bidder/products/${skuId}/strategy/execution`,
    { method: 'PUT', body: JSON.stringify({ execution_mode: executionMode }) }
  );
};

export const runBidderStrategyOnce = async ({ request, accountId, skuId }) => {
  return await request(
    `/api/v1/ozon/${accountId}/bidder/products/${skuId}/strategy/run-once`,
    { method: 'POST' }
  );
};

export const updateBidderStrategyConstraints = async ({ request, accountId, skuId, constraints }) => {
  return await request(
    `/api/v1/ozon/${accountId}/bidder/products/${skuId}/strategy/constraints`,
    { method: 'PUT', body: JSON.stringify(constraints) }
  );
};

export const getOzonAutomations = async ({ request, accountId }) => (
  request(`/api/v1/ozon/${accountId}/bidder/automations`)
);

export const getOzonAutomationProducts = async ({ request, accountId }) => (
  request(`/api/v1/ozon/${accountId}/bidder/automation-products`)
);

export const getOzonSeoDictionaries = async ({ request, accountId }) => (
  request(`/api/v1/ozon-auto-seo/${accountId}/dictionaries`)
);

export const previewOzonPositioning = async ({ request, accountId, fragments, dictionaryId }) => (
  request(`/api/v1/ozon/${accountId}/bidder/automations/positioning-preview`, {
    method: 'POST', body: JSON.stringify({ fragments, dictionary_id: dictionaryId || null }),
  })
);

export const createOzonAutomation = async ({ request, accountId, automation }) => (
  request(`/api/v1/ozon/${accountId}/bidder/automations`, {
    method: 'POST', body: JSON.stringify(automation),
  })
);

export const createOzonAutomationsBatch = async ({ request, accountId, defaults, groups }) => (
  request(`/api/v1/ozon/${accountId}/bidder/automations/batch`, {
    method: 'POST', body: JSON.stringify({ defaults, groups }),
  })
);

export const updateOzonAutomation = async ({ request, accountId, automationId, automation }) => (
  request(`/api/v1/ozon/${accountId}/bidder/automations/${automationId}`, {
    method: 'PUT', body: JSON.stringify(automation),
  })
);

export const setOzonAutomationStatus = async ({ request, accountId, automationId, status }) => (
  request(`/api/v1/ozon/${accountId}/bidder/automations/${automationId}/status?status=${status}`, {
    method: 'PUT',
  })
);

export const getOzonAutomationStrategies = async ({ request }) => (
  request('/api/v1/ozon/bidder/strategies')
);

export const runOzonAutomationCycle = async ({ request, accountId, automationId, apply = false }) => (
  request(`/api/v1/ozon/${accountId}/bidder/automations/${automationId}/cycle?apply=${apply}`, {
    method: 'POST',
  })
);

export const getOzonAutomationEconomics = async ({ request, accountId, automationId, days = 30 }) => (
  request(`/api/v1/ozon/${accountId}/bidder/automations/${automationId}/economics?days=${days}`)
);

export const getOzonAutomationEvents = async ({ request, accountId, automationId, limit = 100 }) => (
  request(`/api/v1/ozon/${accountId}/bidder/automations/${automationId}/events?limit=${limit}`)
);

export const rollbackOzonAutomationAction = async ({ request, accountId, automationId, actionId }) => (
  request(
    `/api/v1/ozon/${accountId}/bidder/automations/${automationId}/actions/${actionId}/rollback`,
    { method: 'POST' },
  )
);

export const setOzonAutomationMode = async ({ request, accountId, automationId, mode }) => (
  request(`/api/v1/ozon/${accountId}/bidder/automations/${automationId}/mode?mode=${mode}`, {
    method: 'PUT',
  })
);

export const getOzonAutomationLimitsContext = async ({ request, accountId, skuIds }) => (
  request(`/api/v1/ozon/${accountId}/bidder/limits-context`, {
    method: 'POST', body: JSON.stringify({ sku_ids: skuIds.map(Number) }),
  })
);

export const getOzonAutomationsTable = async ({ request, accountId, archived = false }) => (
  request(`/api/v1/ozon/${accountId}/bidder/automations/table${archived ? '?archived=true' : ''}`)
);

export const bulkOzonAutomations = async ({
  request, accountId, ids, action, mode, strategyType, objective, permissions, constraints,
}) => (
  request(`/api/v1/ozon/${accountId}/bidder/automations/bulk`, {
    method: 'POST',
    body: JSON.stringify({
      ids, action, mode: mode || null, strategy_type: strategyType || null, objective: objective || null,
      permissions: permissions || null, constraints: constraints || null,
    }),
  })
);
